import type {IBulkActionState} from '@igp/shared/features/bulk-operation';
import {bulkActionsReducer} from '@igp/shared/features/bulk-operation';
import type {IAsyncActionsState} from '@igp/shared/redux/async-actions';
import {asyncActionsReducer} from '@igp/shared/redux/async-actions';
import type {IEntitiesState} from '@igp/shared/redux/entity';
import {EntityReducerCreator} from '@igp/shared/redux/entity';
import {MessageReducerCreator} from '@igp/shared/redux/message';
import type {IRealtimeState} from '@igp/shared/redux/realtime';
import {RealtimeReducerCreator} from '@igp/shared/redux/realtime';
import type {IViewsState} from '@igp/shared/redux/view';
import {ViewReducerCreator} from '@igp/shared/redux/view';
import type {EntityType} from '@models';
import {entityTypes} from '@models';
import type {Reducer} from 'redux';
import {combineReducers} from 'redux';

export type RootReducer = Reducer<
    IEntitiesState<EntityType> & IRealtimeState<EntityType> & IViewsState<EntityType> & IAsyncActionsState & IBulkActionState
>;
export function createRootReducer(): RootReducer {
    return combineReducers({
        entities: new EntityReducerCreator<EntityType>().createReducer(entityTypes),
        realtime: new RealtimeReducerCreator<EntityType>().createReducer(),
        views: new ViewReducerCreator<EntityType>().createReducer(),
        asyncActions: asyncActionsReducer,
        bulkActions: bulkActionsReducer,
        message: new MessageReducerCreator().createReducer(),
    });
}
